<div class="card" id="payments-due-today">
    <div class="card-body">
        <h2 class="card-title">Payments</h2>
        <form [formGroup]="filters">
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="pastDueSwitch" formControlName="past" />
                <label class="custom-control-label" for="pastDueSwitch">Past Due Only</label>
            </div>
        </form>
    </div>
    <ul class="list-group list-group-flush pay-list">
        @if ((!payments || (payments.length <= 0))) { 
            <li class="list-group-item">No payments at this time.</li>
        }
            
        @for (payment of payments; track payment) {
            <li class="list-group-item" (click)="selected($event, payment)">
                @if (!payment.url) {
                    <span class="material-icons">directions_car</span>
                }
                @if (payment.url) {
                    <img [src]="payment.url" />
                }
                <p class="due {{dueToClass(payment.due)}}">{{payment.due | date:'M/d'}}</p>
                <div class="text-truncate">
                    <p class="title">{{payment.contact}}</p>
                    <p class="subtitle">{{payment.stock}} {{payment.vehicle}}</p>
                </div>
                <div class="currency">
                    <p>{{payment.amount | currency}}</p>
                </div>
            </li>
        }
    </ul>
</div>